module.exports = __webpack_public_path__ + "static/media/suppliers.6d2e74d5.svg";